import {
  FETCH_CURRENCIES,
} from '../../mutation-types';

export default {
  [FETCH_CURRENCIES](state, currencies) {
    state.all = currencies;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/currency/mutations.js